// Provider-independent view of which chat/conversation is currently open.
//
// The new-message toast is produced by NotificationContext, which lives OUTSIDE
// ChatProvider in the app tree, so it can't call useChat(). ChatContext writes the
// open-chat state here on every change; NotificationContext reads it synchronously
// to suppress a toast for the conversation the user is already looking at.
export const chatOpenState = { isChatOpen: false, activeConversationId: null };
